export const colorsChartTheme3 = {
    goals: {
        medium: { light: "rgba(6, 50, 84, 1)", dark: "rgba(244, 244, 244, 1)" }
    },
    cyan: {
        dark: {
            light: "rgba(51, 78, 128, 1)",
            dark: "rgba(76, 103, 153, 1)"
        },
        medium: {
            light: "rgba(80, 117, 185, 1)",
            dark: "rgba(112, 147, 212, 1)"
        },
        light: {
            light: "rgba(124, 151, 203, 1)",
            dark: "rgba(163, 186, 229, 1)"
        },
        darker: {
            light: "rgba(35, 53, 88, 1)",
            dark: "rgba(57, 77, 115, 1)"
        },
        lighter: {
            light: "rgba(124, 151, 203, 1)",
            dark: "rgba(163, 186, 229, 1)"
        },
        disabled: {
            light: "rgba(124, 151, 203, 1)",
            dark: "rgba(163, 186, 229, 1)"
        }
    },
    purple: {
        medium: {
            light: "rgba(220, 105, 4, 1)",
            dark: "rgba(245, 130, 29, 1)"
        },
        darker: {
            light: "rgba(160, 76, 3, 1)",
            dark: "rgba(186, 99, 22, 1)"
        },
        dark: {
            light: "rgba(191, 91, 4, 1)",
            dark: "rgba(217, 115, 26, 1)"
        },
        light: {
            light: "rgba(251, 146, 55, 1)",
            dark: "rgba(255, 162, 82, 1)"
        },
        lighter: {
            light: "rgba(252, 168, 95, 1)",
            dark: "rgba(255, 184, 122, 1)"
        }
    },
    yellow: {
        light: {
            light: "rgba(210, 150, 137, 1)",
            dark: "rgba(235, 186, 176, 1)"
        },
        medium: {
            light: "rgba(201, 127, 111, 1)",
            dark: "rgba(227, 162, 148, 1)"
        },
        dark: {
            light: "rgba(201, 127, 111, 1)",
            dark: "rgba(227, 162, 148, 1)"
        },
        darker: {
            light: "rgba(201, 127, 111, 1)",
            dark: "rgba(227, 162, 148, 1)"
        }
    },
    violet: {
        lighter: {
            light: "rgba(112, 255, 112, 1)",
            dark: "rgba(138, 255, 138, 1)"
        },
        "lighter-weight": {
            light: "rgba(153, 255, 153, 1)",
            dark: "rgba(178, 255, 178, 1)"
        },
        light: {
            light: "rgba(0, 163, 0, 1)",
            dark: "rgba(19, 189, 19, 1)"
        },
        "light-weight": {
            light: "rgba(92, 255, 92, 1)",
            dark: "rgba(127, 227, 127, 1)"
        },

        medium: {
            light: "rgba(0, 122, 0, 1)",
            dark: "rgba(15, 148, 15, 1)"
        },
        dark: {
            light: "rgba(0, 82, 0, 1)",
            dark: "rgba(11, 107, 11, 1)"
        },
        darker: {
            light: "rgba(0, 61, 0, 1)",
            dark: "rgba(9, 87, 9, 1)"
        }
    },
    magenta: {
        medium: {
            light: "rgba(128, 94, 143, 1)",
            dark: "rgba(156, 128, 168, 1)"
        },
        light: {
            light: "rgba(157, 138, 166, 1)",
            dark: "rgba(157, 138, 166, 1)"
        },
        lighter: {
            light: "rgba(184, 163, 194, 1)",
            dark: "rgba(184, 163, 194, 1)"
        }
    },
    gray: {
        medium: {
            light: "rgba(206, 215, 222, 1)",
            dark: "rgba(218, 227, 235, 1)"
        }
    },
    basic: {
        medium: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        },
        dark: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        }
    },
    black: {
        petroleum: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        }
    }
};
